<template>
  <div class="media-up">
    <subfield>
      <template slot="list">
        <trees title="组织结构分组" type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
        <trees type="CATALOG" @getAssets="getAssets" :list="configList" :select="fileId" :isGetAll="false"></trees>
      </template>
      <template slot="content">
        <enfold-uc>
          <template slot="up">
            <div class="c-u-left">
              <div>
                <el-upload
                  class="upload-files"
                  ref="upload"
                  :action="baseURL+'/admin/material/upfile'"
                  :data="uploadFile"
                  :file-list="fileList"
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="onFileChange"
                  :before-upload="beforePpload"
                  :on-progress="onFileProgress"
                  :on-success="onFileSuccess"
                  :on-exceed="onFileExceed"
                  :accept="acceptType"
                  :before-remove="beforeRemove"
                  :on-remove="onFileremove"
                  multiple
                >
                  <el-button slot="trigger" round size="mini">{{upTileType}}上传</el-button>
                </el-upload>
              </div>
              <el-button round size="mini" @click="submitUpload">全部开始</el-button>
              <el-button round size="mini" @click="uploadStop">全部停止</el-button>
              <el-button round size="mini" @click="clearUploadDerform">清空完成</el-button>
            </div>

            <div
              class="c-u-right"
              v-if="$route.params.event"
              @click="$router.push({name: 'AddSchedule',params: {id:$route.params.id, event:$route.params.event ,iscopy:$route.params.iscopy}})"
            >
              <span style>返回发布</span>
              <img class="icon" src="@/assets/images/public/public_closearrow.png" alt />
            </div>
          </template>
          <template slot="center">
            <el-table
              ref="multipleTable"
              :data="MediaUpList"
              tooltip-effect="dark"
              empty-text="暂无上传文件"
              style="width: 100%"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column prop="name" label="文件名称" width="180"></el-table-column>
              <el-table-column label="状态">
                <div slot-scope="scope" class="percentage">
                  <el-progress
                    :format="format"
                    :percentage="scope.row.status === 'success' ? scope.row.percentage:scope.row.percentage === 100 ? 99:scope.row.percentage"
                  ></el-progress>
                  <div class="stop-img">
                    <img v-show="scope.row.status === 'stop'" src="@/assets/images/public/public_deactivate.png" alt />
                  </div>
                </div>
              </el-table-column>
              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <div class="operation">
                    <img
                      v-show="scope.row.status === 'success'"
                      class="icon"
                      src="@/assets/images/public/public_preview.png"
                      @click.stop="handlePreview (scope.$index,{type: fileType, ref_url: scope.row.response.data.url})"
                      alt
                    />
                    <img
                      v-show="scope.row.status !== 'success'"
                      class="icon"
                      src="@/assets/images/public/public_retransmission.png"
                      @click.stop="handleRetransmission (scope.$index, scope.row)"
                      alt
                    />
                    <img
                      v-show="scope.row.status !== 'success'"
                      class="icon"
                      src="@/assets/images/public/public_cancelupload.png"
                      @click.stop="handleCancelupload (scope.$index, scope.row)"
                      alt
                    />
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </enfold-uc>
      </template>
    </subfield>
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" title="取消上传">
      <div class="dd-dialog">请问是否要取消上传当前文件？</div>
    </del-dialog>
    <preview :previewData="previewData" @previewVisible="previewVisible"></preview>
  </div>
</template>

<script>
import subfield from '@/components/basics/Subfield'
import trees from '@/components/basics/Trees'
import EnfoldUc from '@/components/basics/EnfoldUC'
import DelDialog from '@/components/basics/DelDialog'
import Preview from '@/components/basics/Preview'
import { mPreview } from "@/components/basics/mixins";
import { handleDataAndSign } from "@/assets/scripts/handleDataAndSign";

export default {
  name: 'playlist',
  mixins: [mPreview],
  data() {
    return {
      groupList: [],
      configList: [],
      fileList: [],
      MediaUpList: [],
      multipleSelection: [],
      baseURL: '/api',
      groupId: this.$cookies.get("group_id"),
      dirId: '2',
      fileType: "",
      fileId: "2", // 默认类型选择图片
      upTileType: "",
      uploadFile: {},
      acceptType: "image/*",
      DelDialogVisible: false,
      delItemIndex: -1
    }
  },
  created() {
    this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
    });
    this.$http.post("/admin/material/configList", { flag: 1 }, data => {
      this.configList = data.dir;

      // 初始化上传类型选择，默认选择类型列表的图片类型
      this.fileSwitch("2");
    });
  },
  methods: {
    // 上传进度显示格式化
    format(percentage) {
      return percentage === 100 ? '上传完成' : `${parseInt(percentage)}%`;
    },
    // 开始上传所有文件
    submitUpload() {
      if (this.MediaUpList.length === 0) {
        this.$msg({ showClose: true, message: '请选择上传文件!', type: 'warning' });
        return;
      }
      if (this.dirId === 0) {
        this.$msg({ showClose: true, message: '请选择上传目录!', type: 'warning' });
        return;
      }
      this.MediaUpList.forEach((file) => {
        file.status === 'stop' ? file.status = "ready" : 0;
      });
      this.$refs.upload.submit();
    },
    // 停止全部上传
    uploadStop() {
      this.MediaUpList.forEach((file) => {
        this.$refs.upload.abort(file);
        file.status !== "ready" && file.status !== 'success' ? file.status = 'stop' : 0;
      });
    },
    // 清除所有完成上传的文件
    clearUploadDerform() {
      while (this.MediaUpList.filter(file => file.status === 'success').length > 0) {
        this.MediaUpList.forEach((file, index) => {
          if (file.status === 'success') {
            this.$refs.upload.abort(file);
            this.MediaUpList.splice(index, 1);
          }
        });
      }
    },
    // 添加文件、上传成功和上传失败时都会被调用
    onFileChange(file, fileList) {
      if (this.MediaUpList.length === 0) {
        this.MediaUpList = fileList
      } else {
        console.log("上传失败或成功执行！");
      }
    },
    // 文件上传时的钩子
    onFileProgress(event, file, fileList) {
      this.MediaUpList = fileList
      console.log(this.MediaUpList);
    },
    // 文件上传成功时的钩子
    onFileSuccess(response, file, fileList) {
      // console.log(response, file, fileList);
      if (response.status != 1) {
        this.$msg({ showClose: true, message: response.tips, type: 'warning' });
        return;
      }
      this.handleUploadParam(response);
      if (fileList.every((tiem) => { return tiem.response })) {
        console.log("全部上传完成！");
      }
    },
    // 将上传的文件写到数据库
    handleUploadParam(response) {
      let uploadParam = {
        type: this.fileType,
        group_id: this.groupId,
        dir_id: this.dirId,
        fids: response.data.id,
        names: response.data.name,
        urls: encodeURIComponent(response.data.url)
      };
      this.$http.post("/admin/material/add", uploadParam, data => {
        console.log(data);
      });
    },
    // 上传文件之前的钩子
    // eslint-disable-next-line no-unused-vars
    beforePpload(file) {
      let formData = {};
      formData.dir_id = this.dirId;
      let data = handleDataAndSign("/admin/material/upfile", formData);
      // 必须这样的格式设置 uploadFile 不然无法通过上传校验
      this.uploadFile.dir_id = data.dir_id;
      this.uploadFile.v = data.v;
      this.uploadFile.t = data.t;
      this.uploadFile.token = data.token;
      this.uploadFile.s = data.s;
    },
    // 文件上传个数限制钩子
    onFileExceed(files, fileList) {
      if (fileList.length > 20) {
        this.$msg({ showClose: true, message: '文件上传个数不可以大于20个!', type: 'warning' });
        return false;
      }
    },
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      console.log(file, fileList);
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    onFileremove(file, fileList) {
      console.log(file, fileList);
    },
    getAssets(ids) {
      // console.log(ids);
      if (ids.type === "GROUP") {
        this.groupId = ids.id
      }
      if (ids.type === "CATALOG") {
        // 当选择的目录无文件类型就返回
        if (!ids.fileType) {
          console.log("当前目录无文件类型");
          return;
        }
        // 当进行目录切换的时候需要清除所有上传
        {
          this.uploadStop();
          this.MediaUpList = [];
          this.$refs.upload.clearFiles();
        }
        this.dirId = ids.id;
        this.fileSwitch(ids.fileType);
      }
    },
    fileSwitch(type) {
      this.fileType = type;
      this.upTileType = { '1': '视频', '2': '图片', '6': '音乐' }[this.fileType];
      this.acceptType = { '1': 'video/*', '2': 'image/*', '6': 'audio/*' }[this.fileType];
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 重传当前暂停文件
    // eslint-disable-next-line no-unused-vars
    handleRetransmission(index, row) {
      if (this.MediaUpList[index].status !== "ready") {
        this.MediaUpList[index].status = "ready";
        this.$refs.upload.submit();
      }
    },
    // 删除当前上传文件
    // eslint-disable-next-line no-unused-vars
    handleCancelupload(index, row) {
      this.delItemIndex = index;
      this.DelDialogVisible = true;
    },
    DelCloseDialog(isConfirm = false) {
      if (isConfirm) {
        this.$refs.upload.abort(this.MediaUpList[this.delItemIndex]);
        this.MediaUpList.splice(this.delItemIndex, 1);
      }
      this.DelDialogVisible = false;
    }
  },
  components: {
    subfield,
    trees,
    EnfoldUc,
    DelDialog,
    Preview
  }
}
</script>

<style lang="scss" scoped>
.media-up {
  width: 100%;
  height: 100%;
  .c-u-left {
    display: flex;
    .el-button {
      margin-left: 10px;
    }
  }
  .c-u-right {
    display: flex;
    align-items: center;
    .icon {
      width: 30px;
      height: 30px;
      margin-right: 0px;
    }
  }
  .percentage {
    display: flex;
    /deep/ .el-progress {
      width: 100%;
      display: flex;
      // justify-content:space-between;
      align-items: center;
    }
    .stop-img {
      width: 30px;
      height: 30px;
      img {
        width: 30px;
        height: 30px;
      }
    }
  }
  /deep/ .el-progress-bar {
    width: 96%;
  }
  /deep/ .cell {
    font-size: 16px;
  }
  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: #2fb3ff;
    }
    th:last-child > .cell {
      text-align: center;
    }
  }
  /deep/ .el-progress__text {
    min-width: 60px;
  }
  .operation {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .icon {
      margin: 0px;
    }
  }
  .icon {
    width: 30px;
    height: 30px;
    margin-right: 25px;
  }
}
</style>